import React from 'react';
import { Navigate } from 'react-router-dom';
import usePermissions from '../../hooks/usePermissions';

/**
 * Route guard mirroring the server-side rule for a module: requires the given
 * [module, action] permission and, optionally, Internal Ink It staff. Denied
 * users are redirected to the dashboard (the API enforces the same rule anyway).
 */
export function RequireModule({ module, action, internal = false, children }) {
    const { can, internal: isInternal, loading } = usePermissions();

    if (loading) return null;
    if (internal && !isInternal) return <Navigate to="/dashboard" replace />;
    if (!can(module, action)) return <Navigate to="/dashboard" replace />;

    return children;
}

export default RequireModule;
